export const translations = {
  pt: {
    // nav
    nav_home: "Início",
    nav_about: "História",
    nav_services: "Serviços",
    nav_gallery: "Galeria",
    nav_booking: "Marcar Serviço",
    // hero
    hero_title_1: "Performance",
    hero_title_2: "Extrema",
    hero_subtitle: "Suspensões de Competição desde 1999",
    hero_desc: "Oficina especializada em suspensões com mais de 25 anos de experiência em alta competição MXGP e MotoGP",
    cta_book: "Marque o Seu Serviço",
    cta_history: "Conheça a Nossa História",
    // stats
    stat_years: "Anos de Experiência",
    stat_tuned: "Suspensões Afinadas",
    stat_dedication: "Dedicação",
    // history home
    home_history_title: "A Nossa História",
    home_history_p1: "A Barbo Factory é uma oficina especializada em suspensões, dedicada a oferecer serviços de excelência para pilotos profissionais, amadores e entusiastas. Fundada por Rui Silva, a Barbo Factory beneficia de mais de 25 anos de experiência em alta competição.",
    home_history_p2: "A missão da Barbo Factory é clara: proporcionar suspensões de máxima performance, otimizando a experiência e o desempenho de cada cliente, independentemente do nível de competição ou paixão pela condução.",
    btn_history: "História",
    // services section (home)
    services_title: "Serviços Especializados",
    services_subtitle: "Soluções personalizadas para maximizar o desempenho e o conforto",
    btn_services: "Serviços",
    svc_revision_title: "Revisão de Suspensões",
    svc_revision_desc: "Manutenção completa e profissional de suspensões para motos offroad, onroad e BTT",
    svc_prep_title: "Preparação de Suspensões",
    svc_prep_desc: "Preparação e otimização de suspensões para competição e uso extremo",
    svc_software_title: "Motorcycle Setup Analysis Software",
    svc_software_desc: "Análise técnica avançada com software especializado para otimização de setup",
    // gallery home
    gallery_title: "Galeria de Trabalhos",
    gallery_subtitle: "Precisão técnica e qualidade em cada projeto",
    btn_gallery: "Galeria",
    // booking cta home
    booking_cta_title: "Marque o Seu Serviço",
    booking_cta_subtitle: "Preencha o formulário e entraremos em contacto para confirmar",
    // about page
    about_title: "A Nossa História",
    about_subtitle: "25 Anos de Excelência em Alta Competição",
    about_founder: "Fundador: Rui Silva",
    about_p1: "A Barbo Factory é uma oficina especializada em suspensões, dedicada a oferecer serviços de excelência para pilotos profissionais, amadores e entusiastas. Fundada por Rui Silva, a Barbo Factory beneficia de mais de 25 anos de experiência em alta competição.",
    about_p2: "Rui Silva desenvolveu a sua carreira trabalhando para prestigiadas equipas de fábrica como a Yamaha Factory MXGP, WP Factory Suspensions e KTM MotoGP, assumindo funções como técnico de pista e engenheiro de pista no exigente mundo MXGP e MotoGP.",
    about_mission: "A missão da Barbo Factory é clara: proporcionar suspensões de máxima performance, otimizando a experiência e o desempenho de cada cliente, independentemente do nível de competição ou paixão pela condução.",
    about_teams_title: "Experiência em Equipas de Fábrica",
    role_track_tech: "Técnico de Pista",
    role_suspension_spec: "Especialista de Suspensões",
    role_track_eng: "Engenheiro de Pista",
    // services page
    sp_title: "Serviços Especializados",
    sp_subtitle: "Soluções personalizadas para maximizar o desempenho e o conforto",
    s1_title: "Revisão de Suspensões",
    s1_desc: "Revisão completa de suspensões para offroad, onroad e BTT",
    s2_title: "Preparação de Suspensões",
    s2_desc: "Preparação personalizada para competição e uso diário",
    s3_title: "Análise de Setup",
    s3_desc: "Software de análise para optimização do setup da mota",
    s4_title: "Assistência em Pista",
    s4_desc: "Testes em pista e ajustes de setup em tempo real",
    s5_title: "Serviço E-Bike",
    s5_desc: "Manutenção de motores e suspensões de e-bikes",
    how_title: "How We Work",
    // gallery page
    gp_title: "Galeria de Trabalhos",
    gp_subtitle: "Precisão técnica e qualidade em cada projeto",
    testimonials_title: "Testemunhos",
    testimonials_subtitle: "O que os nossos clientes dizem",
    g_workshop: "Oficina",
    g_technical: "Técnico",
    g_parts: "Peças",
    g_competition: "Competição",
    cat_All: "Todos",
    cat_Competition: "Competição",
    cat_Technical: "Técnico",
    cat_Parts: "Peças",
    cat_Workshop: "Oficina",
    // booking page
    bp_title: "Marque o Seu Serviço",
    bp_subtitle: "Preencha o formulário e entraremos em contacto para confirmar",
    f_name: "Nome Completo",
    f_email: "Email",
    f_phone: "Telefone",
    f_vehicle_type: "Tipo de Veículo",
    f_vehicle_model: "Marca/Modelo",
    f_service_type: "Tipo de Serviço",
    f_date: "Data Preferencial",
    f_message: "Mensagem (opcional)",
    f_select: "Selecionar...",
    f_submit: "Enviar Pedido",
    f_success: "Pedido enviado com sucesso! Entraremos em contacto em breve.",
    contact_title: "Contacto",
    contact_phone: "Telefone",
    contact_email: "Email",
    contact_hours: "Horário",
    expect_title: "O Que Esperar",
    expect_1: "Analisamos o seu pedido em 24 horas",
    expect_2: "Chamada de confirmação para discutir detalhes",
    expect_3: "Consulta profissional à chegada",
    expect_4: "Preços transparentes e prazos claros",
    open_maps: "Abrir no Maps",
    // footer
    footer_tagline: "Suspensões de competição de alta performance desde 1999.",
    footer_links: "Links Rápidos",
    footer_contact: "Contacto",
    footer_rights: "Todos os direitos reservados.",
    // admin
    admin_title: "Admin Dashboard",
    admin_subtitle: "Barbo Factory - Área Restrita",
    admin_user: "Utilizador",
    admin_password: "Password",
    admin_enter: "ENTRAR",
    admin_back: "← Voltar ao website",
    admin_error: "Credenciais inválidas. Tente novamente.",
  },
  en: {
    nav_home: "Home",
    nav_about: "About",
    nav_services: "Services",
    nav_gallery: "Gallery",
    nav_booking: "Book Service",
    hero_title_1: "Extreme",
    hero_title_2: "Performance",
    hero_subtitle: "Competition Suspensions since 1999",
    hero_desc: "Suspension workshop with over 25 years of experience in top-level MXGP and MotoGP competition",
    cta_book: "Book Your Service",
    cta_history: "Discover Our Story",
    stat_years: "Years of Experience",
    stat_tuned: "Suspensions Tuned",
    stat_dedication: "Dedication",
    home_history_title: "Our Story",
    home_history_p1: "Barbo Factory is a workshop specialized in suspensions, dedicated to delivering excellence for professional riders, amateurs and enthusiasts. Founded by Rui Silva, Barbo Factory benefits from over 25 years of top-level competition experience.",
    home_history_p2: "Barbo Factory's mission is clear: to deliver maximum performance suspensions, optimizing the experience and performance of every client, regardless of competition level or passion for riding.",
    btn_history: "Our Story",
    services_title: "Specialized Services",
    services_subtitle: "Custom solutions to maximize performance and comfort",
    btn_services: "Services",
    svc_revision_title: "Suspension Service",
    svc_revision_desc: "Complete professional suspension maintenance for offroad, onroad and MTB",
    svc_prep_title: "Suspension Preparation",
    svc_prep_desc: "Preparation and optimization of suspensions for competition and extreme use",
    svc_software_title: "Motorcycle Setup Analysis Software",
    svc_software_desc: "Advanced technical analysis with specialized software for setup optimization",
    gallery_title: "Work Gallery",
    gallery_subtitle: "Technical precision and quality in every project",
    btn_gallery: "Gallery",
    booking_cta_title: "Book Your Service",
    booking_cta_subtitle: "Fill in the form and we will contact you to confirm",
    about_title: "Our Story",
    about_subtitle: "25 Years of Excellence in Top Competition",
    about_founder: "Founder: Rui Silva",
    about_p1: "Barbo Factory is a workshop specialized in suspensions, dedicated to delivering excellence for professional riders, amateurs and enthusiasts. Founded by Rui Silva, Barbo Factory benefits from over 25 years of top-level competition experience.",
    about_p2: "Rui Silva built his career working for prestigious factory teams such as Yamaha Factory MXGP, WP Factory Suspensions and KTM MotoGP, taking on roles as track technician and track engineer in the demanding world of MXGP and MotoGP.",
    about_mission: "Barbo Factory's mission is clear: to deliver maximum performance suspensions, optimizing the experience and performance of every client, regardless of competition level or passion for riding.",
    about_teams_title: "Factory Team Experience",
    role_track_tech: "Track Technician",
    role_suspension_spec: "Suspension Specialist",
    role_track_eng: "Track Engineer",
    sp_title: "Specialized Services",
    sp_subtitle: "Custom solutions to maximize performance and comfort",
    s1_title: "Suspension Service",
    s1_desc: "Complete suspension service for offroad, onroad and MTB",
    s2_title: "Suspension Preparation",
    s2_desc: "Custom preparation for competition and daily use",
    s3_title: "Setup Analysis",
    s3_desc: "Analysis software for motorcycle setup optimization",
    s4_title: "Trackside Support",
    s4_desc: "Track testing and real-time setup adjustments",
    s5_title: "E-Bike Service",
    s5_desc: "Maintenance of e-bike motors and suspensions",
    how_title: "How We Work",
    gp_title: "Work Gallery",
    gp_subtitle: "Technical precision and quality in every project",
    testimonials_title: "Testimonials",
    testimonials_subtitle: "What our clients say",
    g_workshop: "Workshop",
    g_technical: "Technical",
    g_parts: "Parts",
    g_competition: "Competition",
    cat_All: "All",
    cat_Competition: "Competition",
    cat_Technical: "Technical",
    cat_Parts: "Parts",
    cat_Workshop: "Workshop",
    bp_title: "Book Your Service",
    bp_subtitle: "Fill in the form and we will contact you to confirm",
    f_name: "Full Name",
    f_email: "Email",
    f_phone: "Phone",
    f_vehicle_type: "Vehicle Type",
    f_vehicle_model: "Brand/Model",
    f_service_type: "Service Type",
    f_date: "Preferred Date",
    f_message: "Message (optional)",
    f_select: "Select...",
    f_submit: "Send Request",
    f_success: "Request sent successfully! We will contact you shortly.",
    contact_title: "Contact",
    contact_phone: "Phone",
    contact_email: "Email",
    contact_hours: "Hours",
    expect_title: "What to Expect",
    expect_1: "We review your request within 24 hours",
    expect_2: "Confirmation call to discuss details",
    expect_3: "Professional consultation on arrival",
    expect_4: "Transparent pricing and clear timelines",
    open_maps: "Open in Maps",
    footer_tagline: "High-performance competition suspensions since 1999.",
    footer_links: "Quick Links",
    footer_contact: "Contact",
    footer_rights: "All rights reserved.",
    admin_title: "Admin Dashboard",
    admin_subtitle: "Barbo Factory - Restricted Area",
    admin_user: "Username",
    admin_password: "Password",
    admin_enter: "SIGN IN",
    admin_back: "← Back to website",
    admin_error: "Invalid credentials. Please try again.",
  },
};
